module.exports = __webpack_public_path__ + "static/media/4532.f2380fc1.jpg";